'use client';
import { DEFAULT_SKELETON_ANIMATIONS } from '../../../Skeleton.animations.js';

/**
 * Задаёт анимацию присутствия скелетона.
 * */ const getAnimationStyles = ({ animation, animationOptions })=>{
    if (!animation) {
        return {
            animation: 'none'
        };
    }
    const animationKeyframes = DEFAULT_SKELETON_ANIMATIONS[animation];
    const { animationDirection = 'normal', animationDuration = '1.8s', timingFunction = 'ease-in-out', iterationCount = 'infinite' } = animationOptions || {};
    return {
        animation: animationKeyframes,
        animationDirection,
        animationDuration,
        animationTimingFunction: timingFunction,
        animationIterationCount: iterationCount
    };
};

export { getAnimationStyles };
//# sourceMappingURL=getAnimationStyles.js.map
